import axios from 'axios';

import BaseService from '../baseService';

export default class AuthService extends BaseService {

  // eslint-disable-next-line no-unused-vars
  async login(data) {
    const response = await axios.post(process.env.VUE_APP_API + '/user/login', data);
    console.log(response);
    return response;
  }
  async logout() {
    const URI = '/logout';
    const response = await this.postAsync(URI);
    return response;
  }
  async register(data) {
    const URI = '/user/register';
    const response = await axios.post(process.env.VUE_APP_API + URI, data);
    return response;
  }
  async profile(data) {
    const URI = `/profile/${data.id}`;
    const response = await axios.get(process.env.VUE_APP_API + URI)
    return response
  }
  async update(data) {
    const URI = `/profile/${data.id}`;
    const response = await axios.patch(process.env.VUE_APP_API + URI, data)
    return response
  }

  async allUsers(id) {
    const url = "/admin";
    const response = await axios.post(process.env.VUE_APP_API + url, id);
    return response;
  }
}